export default __webpack_public_path__ + "static/media/stripe-middle-mobile.7475ca59.svg";